import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const IpadappServices: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
    
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Customized Applications" />
            <KEYBlue text="Gaming Applications" />
            <KEYBlue text="Brand Building/Marketing Applications" />
            <KEYBlue text="Social Networking Applications" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Utility & Productivity Applications" />
            <KEYBlue text="Web-Based Applications" />
            <KEYBlue text="Education / Travel / Health & Fitness Applications, etc." />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default IpadappServices
